  {
    "Basic": [
      {
        "menu_label": "Consumer Interest",
        "menu_id": "participant_leads",
        "landing_component": "participantLeadsList",
        "display": "y"
      },
      {
        "menu_label": "Personal Assistant Interests",
        "menu_id": "provider_leads",
        "landing_component": "providerLeadsList",
        "display": "y"
      }
    ]
  }